import { render, staticRenderFns } from "./AddPermissionProfiles.vue?vue&type=template&id=222f4087&"
import script from "./AddPermissionProfiles.vue?vue&type=script&lang=js&"
export * from "./AddPermissionProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports